// extracted by mini-css-extract-plugin
module.exports = {"bi-chevron-down":"MailchimpForBuyers_bi-chevron-down__1GYju","buyerForm":"MailchimpForBuyers_buyerForm__2uoic"};